import React from 'react';
import { Spinner, Card, Button, Modal, Form, Col , Row,Navbar, Container, Image } from 'react-bootstrap';
import axios from 'axios';
import { Constants } from "../constants";
import GridSystem from './grid_system';
import SiteMenu from "./menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';
import ReactGA from "react-ga4";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import { MultiSelect } from "react-multi-select-component";
import ContractDetailsCard from './orders/orders_contract_details_card';



class BolandLandingPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            user: props.location.state.user,
            selectedOrderType: 'Contract',
            contractData: [],
            accounts: [],
            selectedAccounts: [],
            accountSearchString: '',
            contractPage: 1,
            totalSize: 0,
            sizePerPage: 20,
            contractLoading: true,
            errors:''
        }

        this.getAllData = this.getAllData.bind(this);
        this.createContractCards = this.createContractCards.bind(this);
        this.createCards = this.createCards.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleContractorSubmit = this.handleContractorSubmit.bind(this);
        this.handleContractorPin = this.handleContractorPin.bind(this);
        this.showButton = this.showButton.bind(this);
        this.openOrderSelect = this.openOrderSelect.bind(this);
        this.GoToBolandOpenOrders = this.GoToBolandOpenOrders.bind(this);
    }
    componentDidMount() {
        this.getAllData();
    }
    getAllData() {

        this.setState({
            contractLoading: true,
        });
        ReactGA.event({
            category: 'Search',
            action: 'Open Orders',
            label: 'Open Orders Search'
        });

        axios.get(`${Constants.apiURL}/api/Order/GetContractOrders`, {
            params: {
                user: this.state.user.username,
                page: 1,
                searchTerm: this.state.searchTerm,
                accountSearchString: this.state.accountSearchString
            }
        }).then(response => {
            if (response.data) {
                let x = JSON.parse(response.data.data);
                this.setState(() => ({
                    contractData: x,
                    contractPage: 1,
                    contractLoading: false
                }));
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ contractLoading: false });
            console.log('request failed', response)
        });
    }


    handleClose() {
        this.setState({ showModal: false });
    }
    handleContractorPin(event) {
        this.setState({
            contractorPin: event.target.value
        });
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '30px', backgroundColor: '#1F419B' }} variant="primary" disabled>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>;
        }
        else {
            return <Button variant="primary" name="confirm" onClick={this.handleContractorSubmit} style={{ backgroundColor: '#1F419B' }}>
                Submit
            </Button>;
        }
    }

    createContractCards() {
        let items = [];
        if (this.state.contractData.length == 0) {
            return <div class="row-gray" style={{ width: '100%' }}> <Form.Label style={{ paddingTop: '10px' }}>No open contracts</Form.Label></div>
        }
        items = this.state.contractData.map(function (item, index) {
            var className = (index % 2 == 0) ? "row-white" : "row-gray";
            return <ContractDetailsCard user={this.state.user} id={item.OrderKey} key={item.OrderKey} data={item} class={className} />;
        }.bind(this));
        return items;
    }


    handleContractorSubmit() {
        this.setState({ loading: true });
        axios.get(`${Constants.apiURL}/api/Identity/LoginContractor`, {
            params: {
                username: this.state.user.username,
                contractorPin: this.state.contractorPin
            }
        }).then(response => {
            if (response.data) {
                this.setState({
                    showModal: false,
                    loading: false
                });
                this.props.history.push({
                    pathname: "/contractor_portal",
                    state: {
                        user: this.state.user,
                        contractor: response.data
                    }
                });
            }
            else {
                alert('Invalid access code.');
                this.setState({
                    loading: false
                });
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    createCards(items) {
        return items.filter((item) => { return item.visible }).map(item =>
            <Card className='text-center landing-card' style={{ width: '250px', maxHeight:'207px', border: 0, cursor: 'pointer' }} onClick={item.onClick} visible={item.visible}>
                <Card.Body style={{ backgroundColor: '#1F419B', color: 'white', height: '40px', padding: '0px', border: 0 }}>
                    <Card.Title style={{ textAlign: 'center', margin: 0, height: '100%', padding: '0.5rem', border: 0 }}>{item.label}</Card.Title>
                </Card.Body>
                <Card.Img variant="bottom" fluid src={item.imageSrc} style={{minHeight:'160px'}} />
            </Card>
        );
    }

    openOrderSelect(e) {
        let selTO = e.value;
        this.setState({ selectedOrderType: e.value });
        //alert('select option:' + e.value);
    }
    GoToBolandOpenOrders() {

        this.props.history.push({
            pathname: '/boland_open_orders',
            state: {
                user: this.state.user
            }
        });
    }


    render() {
        const showModal = this.state.showModal;
        const openOrders = [
            'Invoices       ',
            'Contracts       ',
            'Part & Supplies ',
            'Services        '];


        return (
            <div class='landing-grid'>
                <SiteMenu user={this.state.user} currentPage='landingPage' />
                <Button style={{ backgroundColor: '#00973A', marginRight: '10px' }} variant="primary" type="submit" onClick={this.GoToBolandOpenOrders}>
                    Boland Open Orders
                </Button>

                <Modal show={showModal} onHide={this.handleClose}>
                    <Modal.Header closeButton style={{ backgroundColor: '#1F419B', color: '#FFFFFF' }}>
                        <Modal.Title>Contractor Portal Login</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Enter your contractor access code:</Form.Label>
                                <Form.Control autoFocus onChange={this.handleContractorPin} maxLength="20" />
                            </Form.Group>
                            <Form.Label style={{ fontStyle: 'italic' }}>Not sure of your access code?<br />Please contact your Boland salesperson</Form.Label>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer style={{ justifyContent: 'flex-start' }}>
                        {this.showButton()}
                        <Button variant="secondary" name="cancel" onClick={this.handleClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Form.Label style={{
                    paddingLeft: '25px',paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B', paddingTop: '10px'
                }}>
                    Welcome to Boland internal landing page, {this.state.user.firstname} {this.state.user.lastname}</Form.Label><br />
                {/*<Form.Label style={{ paddingLeft: '25px', paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', paddingTop: '0px', fontWeight:'bold', fontSize: '15px' }}>*/}
                {/*    Open Orders & Invoices</Form.Label>*/}
                <div style={{paddingLeft:'20px'}}>
                    <Row>
                        <Col md={1} style={{
                            fontSize: '24px', textAlign:'right'}} >Tracking</Col>
                        <Col md={2}>
                                 <Dropdown options={openOrders} onChange={this.openOrderSelect} value={this.state.selectedOrderType} />
                        </Col>

                    </Row>
                    <Row>
                        <Col md={12} style={{ paddingRight: 10 }}>
                            <div style={{backgroundColor: '#696B73', padding: 5, borderRadius: '5px', display: 'flex', flexDirection: 'row'}}>
                                <Form.Label style={{ marginBottom: 0, fontWeight: 'bold', color: 'white', fontSize: 20, verticalAlign: 'middle' }}>Contracts</Form.Label>
                            </div>
                            <div style={{ display: 'flex', position: 'relative', justifyContent: 'center', marginTop: 5 }} hidden={!this.state.contractLoading}>
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </div>
                            <div hidden={this.state.contractLoading}>
                                {this.createContractCards()}
                            </div>
                            <div style={{ display: 'flex' }}>
                                <Button name="contractPrevious" size="sm" disabled={this.state.contractPage == 1} style={{ width: '50px', marginLeft: 'auto' }} onClick={this.handlePaging} >&lt;&lt;</Button>
                                <Button name="contractNext" size="sm" disabled={this.state.contractData.length < 4} style={{ width: '50px', marginLeft: 5 }} onClick={this.handlePaging} >&gt;&gt;</Button>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div>
                </div>
            </div>
        );
    }
}
export default BolandLandingPage;